const cpfMask = [
  /[0-9]/, /[0-9]/, /[0-9]/, ".",
  /[0-9]/, /[0-9]/, /[0-9]/, ".",
  /[0-9]/, /[0-9]/, /[0-9]/, "-",
  /[0-9]/, /[0-9]/,
];

const cnpjMask = [
  /[0-9]/, /[0-9]/, ".",
  /[0-9]/, /[0-9]/, /[0-9]/, ".",
  /[0-9]/, /[0-9]/, /[0-9]/, "/",
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, "-",
  /[0-9]/, /[0-9]/,
];

const maskCpfCnpj = (rawValue = "") => {
  const digits = String(rawValue).replace(/\D/g, "");
  return digits.length > 11 ? cnpjMask : cpfMask;
};

// ==========================
// DETALHES (VISUALIZAÇÃO)
// Organizado em 3 blocos:
//  - Motorista + Veículo Coleta
//  - Motorista + Veículo Entrega
//  - Motorista + Veículo Devolução
// ==========================
export const formStructure = [
  // 0 - Detalhes do container
  [
    {
      name: "tipoDepot",
      label: "Tipo Depot",
      placeholder: "Ex: Entrega ou Coleta",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
      options: [
        { value: "entrega", label: "Entrega" },
        { value: "coleta", label: "Coleta" },
      ],
    },
    {
      name: "numeroContainer",
      label: "Nº Container",
      placeholder: "Digite o número do container",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "tipoContainer",
      label: "Tipo Container",
      placeholder: "Ex: 20DC, 40HC, 40RH",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
      options: [
        { value: "20DC", label: "20DC" },
        { value: "40DC", label: "40DC" },
        { value: "40H", label: "40H" },
        { value: "40HC", label: "40HC" },
        { value: "40RH", label: "40RH" },
      ],
    },
    {
      name: "referenciaCliente",
      label: "Referência Cliente",
      placeholder: "Digite a referência do cliente",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 1 - Status
  [
    {
      name: "statusPedido",
      label: "Status Pedido",
      placeholder: "Status do pedido",
      colProps: { md: 3 },
      component: "SearchSelect",
      type: "search",
      readOnly: true,
      disabled: true,
      options: [
        { value: "OK", label: "OK" },
        { value: "PENDENTE", label: "PENDENTE" },
      ],
    },
    {
      name: "status",
      label: "Status",
      placeholder: "Status",
      colProps: { md: 3 },
      component: "SearchSelect",
      type: "search",
      readOnly: true,
      disabled: true,
      options: [
        { value: "coleta_no_porto", label: "COLETA PORTO" },
        { value: "baixado_aguardando_cheio_barra_velha", label: "BX CHEIO BV" },
        { value: "baixado_aguardando_cheio_itapoa", label: "BX CHEIO ITA" },
        { value: "baixado_aguardando_vazio_barra_velha", label: "BX VAZIO BV" },
        { value: "baixado_aguardando_vazio_itapoa", label: "BX VAZIO ITA" },
        { value: "finalizado", label: "FINAL" },
      ],
    },
  ],

  // 2 - Coleta (local/data)
  [
    {
      name: "localColeta",
      label: "Local de Coleta",
      placeholder: "Digite o local de coleta",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "dataColeta",
      label: "Data Coleta",
      placeholder: "Selecione a data da coleta",
      component: "DatePickers",
      type: "datetime",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 3 - Entrega (local/data)
  [
    {
      name: "local",
      label: "Local de Entrega",
      placeholder: "Digite o local de entrega",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "dataEntrega",
      label: "Data Entrega",
      placeholder: "Selecione a data da entrega",
      component: "DatePickers",
      type: "datetime",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 4 - Devolução (local/data)
  [
    {
      name: "localDevolucao",
      label: "Local Devolução",
      placeholder: "Digite o local de devolução",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "dataDevolucao",
      label: "Data Devolução",
      placeholder: "Selecione a data de devolução",
      component: "DatePickers",
      type: "datetime",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 5 - Free time
  [
    {
      name: "freeTime",
      label: "Free Time",
      placeholder: "Data de free time",
      component: "DatePickers",
      type: "datetime",
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // ==========================
  // 6 - MOTORISTA COLETA
  // ==========================
  [
    {
      name: "motoristaColetaNome",
      label: "Motorista Coleta",
      placeholder: "Buscar motorista de coleta",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "motoristaColetaCpf",
      label: "CPF",
      placeholder: "CPF",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 7 - VEÍCULO COLETA
  [
    {
      name: "veiculoColetaFrota",
      label: "Frota Veículo Coleta",
      placeholder: "Frota do veículo de coleta",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "veiculoColetaPlaca",
      label: "Placa Veículo Coleta",
      placeholder: "Placa do veículo de coleta",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 8 - CARRETA COLETA
  [
    {
      name: "carretaColetaFrota",
      label: "Frota Carreta Coleta",
      placeholder: "Frota da carreta de coleta",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "carretaColetaPlaca",
      label: "Placa Carreta Coleta",
      placeholder: "Placa da carreta de coleta",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // ==========================
  // 9 - MOTORISTA ENTREGA
  // ==========================
  [
    {
      name: "motoristaEntregaNome",
      label: "Motorista Entrega",
      placeholder: "Buscar motorista de entrega",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "motoristaEntregaCpf",
      label: "CPF",
      placeholder: "CPF",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 10 - VEÍCULO ENTREGA
  [
    {
      name: "veiculoEntregaFrota",
      label: "Frota Veículo Entrega",
      placeholder: "Frota do veículo de entrega",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "veiculoEntregaPlaca",
      label: "Placa Veículo Entrega",
      placeholder: "Placa do veículo de entrega",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // ==========================
  // 11 - MOTORISTA DEVOLUÇÃO
  // ==========================
  [
    {
      name: "motoristaDevolucaoNome",
      label: "Motorista Devolução",
      placeholder: "Buscar motorista de devolução",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "motoristaDevolucaoCpf",
      label: "CPF",
      placeholder: "CPF",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 12 - VEÍCULO DEVOLUÇÃO
  [
    {
      name: "veiculoDevolucaoFrota",
      label: "Frota Veículo Devolução",
      placeholder: "Frota do veículo de devolução",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
    {
      name: "veiculoDevolucaoPlaca",
      label: "Placa Veículo Devolução",
      placeholder: "Placa do veículo de devolução",
      component: "FormField",
      type: "text",
      colProps: { md: 4 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 13 - Responsável / motivo depot
  [
    {
      name: "motDepot",
      label: "Responsável Depot",
      placeholder: "Motivo ou responsável no depot",
      component: "FormField",
      type: "text",
      colProps: { md: 12 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 14 - Observação
  [
    {
      name: "observacao",
      label: "Observação",
      placeholder: "Observações do pedido",
      component: "FormField",
      type: "textarea",
      colProps: { md: 12 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 15 - Anotações de Programação
  [
    {
      name: "anotacoesProgramacao",
      label: "Anotações de Programação",
      placeholder: "Observações da programação",
      component: "FormField",
      type: "textarea",
      colProps: { md: 12 },
      readOnly: true,
      disabled: true,
    },
  ],

  // 16 - Anotações Operacionais
  [
    {
      name: "anotacoesOperacionais",
      label: "Anotações Operacionais",
      placeholder: "Observações operacionais",
      component: "FormField",
      type: "textarea",
      colProps: { md: 12 },
      readOnly: true,
      disabled: true,
    },
  ],
];

export const formSections = (initialValues = {}) => [
  {
    title: `DETALHES DO CONTAINER ${initialValues.numeroContainer || ""}`,
    rows: [0, 1],
  },
  { title: "LOCAIS E DATAS", rows: [2, 3, 4, 5] },
  { title: "COLETA (MOTORISTA / VEÍCULO / CARRETA)", rows: [6, 7, 8] },
  { title: "ENTREGA (MOTORISTA / VEÍCULO)", rows: [9, 10] },
  { title: "DEVOLUÇÃO (MOTORISTA / VEÍCULO)", rows: [11, 12] },
  { title: "SITUAÇÃO", rows: [13] },
  { title: "ANOTAÇÕES", rows: [14, 15, 16] },
];

// ==========================
// FORMULÁRIO DO PEDIDO (CADASTRO/EDIÇÃO) - mantido
// ==========================
export const pedidoFormStructure = [
  [
    {
      name: "dataColeta",
      label: "Data Coleta",
      placeholder: "Selecione a data da coleta",
      component: "DatePickers",
      type: "date",
      colProps: { md: 3 },
    },
    {
      name: "transportadoraEmitenteCnpj",
      label: "Transportadora Emitente (CNPJ)",
      placeholder: "Digite o CNPJ da transportadora emitente",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
    },
    {
      name: "remetenteCpfCnpj",
      label: "Remetente (CPF/CNPJ)",
      placeholder: "CPF ou CNPJ do remetente",
      component: "MaskedInput",
      type: "text",
      mask: maskCpfCnpj,
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: "destinatarioCpfCnpj",
      label: "Destinatário (CPF/CNPJ)",
      placeholder: "CPF ou CNPJ do destinatário",
      component: "MaskedInput",
      type: "text",
      mask: maskCpfCnpj,
      colProps: { md: 3 },
    },
    {
      name: "tomadorCpfCnpj",
      label: "Tomador (CPF/CNPJ)",
      placeholder: "CPF ou CNPJ do tomador",
      component: "MaskedInput",
      type: "text",
      mask: maskCpfCnpj,
      colProps: { md: 3 },
    },
    {
      name: "tipoTomador",
      label: "Tipo do Tomador",
      placeholder: "Informe o tipo do tomador",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 3 },
      options: [
        { value: "0", label: "Remetente" },
        { value: "1", label: "Expedidor" },
        { value: "2", label: "Recebedor" },
        { value: "3", label: "Destinatário" },
        { value: "4", label: "Outros" },
      ],
    },
    {
      name: "utilizarTipoTomadorInformado",
      label: "Usar Tipo Tomador Informado",
      component: "CheckBox",
      type: "checkbox",
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: "tipoPagamento",
      label: "Tipo de Pagamento",
      placeholder: "Tipo de pagamento",
      component: "SearchSelect",
      type: "search",
      colProps: { md: 3 },
      options: [
        { value: "0", label: "Pago" },
        { value: "1", label: "A Pagar" },
        { value: "2", label: "Outros" },
      ],
    },
    {
      name: "statusPedidoEmissaoTMS",
      label: "Status Pedido Emissão TMS",
      placeholder: "Ex: emitido",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
    },
    {
      name: "tipoOperacaoCodigo",
      label: "Tipo Operação (cod.)",
      placeholder: "Código da operação",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
    },
    {
      name: "tipoCargaEmbarcadorCodigo",
      label: "Tipo Carga Embarcador (cod.)",
      placeholder: "Código da carga do embarcador",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
    },
    {
      name: "valorFrete",
      label: "Valor do Frete",
      placeholder: "Digite o valor do frete",
      component: "FormField",
      type: "text",
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: "observacao",
      label: "Observação",
      placeholder: "Observações do pedido",
      component: "FormField",
      type: "textarea",
      colProps: { md: 12 },
    },
  ],
];

export const pedidoFormSections = () => [
  { title: "DADOS DO PEDIDO", rows: [0, 1, 2] },
  { title: "OBSERVAÇÕES", rows: [3] },
];
